import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { INotificationDelegate } from '../../global/helpers/notification_delegate';
import { IAPProgram } from '../../global/models/ap_model';
import {
  alternate_plan_complete_keys,
  AlternatePlanComparePlansModel
} from '../models/alternate_plan_compare_plans_model';

angular
  .module('capability-ng-academic-planner')
  .service(
    'loadAlternatePlanDetailsCommand',
    function loadAlternatePlanDetailsCommand(
      defineCommandORM: IDefineCommand,
      ngAlternatePlanComparePlansModel: AlternatePlanComparePlansModel,
      $http: ng.IHttpService,
      ngAPNotificationDelegate: INotificationDelegate,
      log: any
    ) {
      return defineCommandORM(
        'loadAlternatePlanDetailsCommand',
        (
          deferred: ng.IDeferred<IQuery[]>,
          programId: IAPProgram['id'],
          updatePlanKey: alternate_plan_complete_keys
        ) => {
          $http
            .get(`/academicplan/program/${programId}/slots/`)
            .then((response: any) => {
              const currentCompareModel = ngAlternatePlanComparePlansModel.read();
              ngAlternatePlanComparePlansModel.clear().write({
                ...currentCompareModel,
                [updatePlanKey]: {
                  id: programId,
                  slots: response.data
                }
              });
              deferred.resolve();
            })
            .catch((e: any) => {
              const errorMessage = 'failed to get details for the plan';
              ngAPNotificationDelegate.error(errorMessage);
              log.error(errorMessage);
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/alternate_plans/commands/load_alternate_plan_details_command.ts